module.exports = __webpack_public_path__ + "static/AVstore-6dfc81f2a87ac049a2f9099fd2e4ae2f.png";